<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" ref="searchForm">
          <el-form-item label="包件编码:">
            <el-input v-model.trim="searchForm.packCode" placeholder="请输入包件编码"></el-input>
          </el-form-item>
          <el-form-item label="包件名称:">
            <el-input v-model.trim="searchForm.packName" placeholder="请输入包件名称"></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" @click="onSearchList" size="mini">搜索</el-button>
          <el-button class="orange-btn" @click="resetForm" size="mini">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="$router.push('/shippingPeriod/packages')">发货周期查询</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>

      <el-table
        @select="serlectRow"
        :data="tableData.records"
        ref="table"
        :height="maxTableHeight"
        border
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column :show-overflow-tooltip="true" prop="packCode" label="包件编码"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="packName" label="包件名称"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plate" label="所属板块"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="upDate" label="上市时间"></el-table-column>
        <el-table-column label="发货周期" min-width="160">
          <template slot-scope="scope">
            <period-cell type="package" :code="scope.row.packCode" :value="scope.row.deliveryCycle" :record="scope.row" style="pointer-events: none;" />
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="monthAvgSale" label="月均销量"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="status" label="是否清仓"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="identifying" label="通用标识件"></el-table-column>
      </el-table>

      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import PeriodCell from '@/views/shippingPeriod/components/PeriodCell';
export default {
  components: { PeriodCell },
  name: 'pack',
  mixins: [pagePathMixin, tableMixin],
  data() {
    return {
      loading: true,
      titleName: '',
      showFlag: false,
      searchForm: {
        packCode: null,
        packName: null,
      },
      requestParam: {},
      dialogFormVisible: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      params: {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
      radio: null,
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    submitModel() {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.$q.goods.addConfig({ data: JSON.stringify(this.requestParam) }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message);
              this.cancel();
              this.onSearch();
            } else {
              this.$message.error(res.message);
              return;
            }
          });
        }
      });
    },
    onSearch() {
      this.loading = true;
      let param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          packCode: this.searchForm.packCode,
          packName: this.searchForm.packName,
        },
      };
      this.$q.pack.listPage({ data: JSON.stringify(param) }).then((res) => {
        this.tableData = res.data;
        if (null != this.tableData.records) {
          this.loading = false;
        }
      });
    },

    resetForm() {
      this.initSearchForm();
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.onSearch();
    },
    initSearchForm() {
      this.searchForm = {
        packCode: null,
        packName: null,
      };
    },
    onSearchList() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.loading = true;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.loading = true;
      this.onSearch();
    },
    exportExcel() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 2147483647;
      this.searchForm.exportTag = true;
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchForm,
        },
        reportName: 'packExport',
      };
      console.log(this.searchForm);
      console.log('params', params);
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped></style>
